export const ArrowShareIcon = ({ className, color = "currentColor" }: { className?: string; color?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.66667 11.6667C7.58714 11.6667 8.33333 10.9205 8.33333 10C8.33333 9.07953 7.58714 8.33334 6.66667 8.33334C5.74619 8.33334 5 9.07953 5 10C5 10.9205 5.74619 11.6667 6.66667 11.6667Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 6.66667C14.2538 6.66667 15 5.92048 15 5C15 4.07953 14.2538 3.33334 13.3333 3.33334C12.4129 3.33334 11.6667 4.07953 11.6667 5C11.6667 5.92048 12.4129 6.66667 13.3333 6.66667Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 16.6667C14.2538 16.6667 15 15.9205 15 15C15 14.0795 14.2538 13.3333 13.3333 13.3333C12.4129 13.3333 11.6667 14.0795 11.6667 15C11.6667 15.9205 12.4129 16.6667 13.3333 16.6667Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.08333 9.08334L11.9167 5.91667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.08333 10.9167L11.9167 14.0833"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowShareIcon;
